import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer/Footer';
import ModalContent from './assets/ModalContent';
import HomeNav from '../../../components/HomeNav';

import layout from './assets/main-screens/warren-screen.png';
import windows from './assets/main-screens/windows-icon.png';

import { FWNavbar } from '../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Dropdown, Tooltip, OverlayTrigger, Modal, Form, Button } from 'react-bootstrap';
import { FaHome, FaPowerOff, FaLightbulb, FaUserPlus } from 'react-icons/fa';
import { MdCropFree, MdClose, MdOutlineSettings, MdLoop } from 'react-icons/md';
import { GiMicroscopeLens } from 'react-icons/gi';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const SIOverview = () => {
	const [user, setUser] = useState('');
	const [password, setPassword] = useState('');

	const [userReg, setUserReg] = useState('');
	const [passwordReg, setPasswordReg] = useState('');

	const [loginStatus, setLoginStatus] = useState(false);

	const handleLogin = (event) => {
		event.preventDefault();
		axios
			.post('https://inovisionqrl-api.interactivetrainingsystems.com/login', {
				username: user,
				password: password,
			})
			.then((response) => {
				console.log(response);
				if (response.data.message) {
					setLoginStatus(response.data.message);
				} else {
					setLoginStatus(response.data[0].name);
				}
			});
		// if (user === 'warren' && password === 'stellantis') {
		// 	setIsLoggedIn(true);
		// } else {
		// 	window.alert('Username or password incorrect!');
		// }
	};

	const handleRegister = (event) => {
		event.preventDefault();
		axios
			.post('https://inovisionqrl-api.interactivetrainingsystems.com/register', {
				username: userReg,
				password: passwordReg,
			})
			.then((response) => {
				console.log(response);
			});
	};

	const renderTooltip = (content) => <Tooltip id="button-tooltip">{content}</Tooltip>;

	// modal state and handlers
	const [modal, setModal] = useState({
		title: '',
		content: '',
	});
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, content) => {
		setModal({ title: title, content: content });
		setShowModal(true);
	};

	useEffect(() => {
		axios.get('https://inovisionqrl-api.interactivetrainingsystems.com/login').then((response) => {
			if (response.data.loggedIn === true) {
				setLoginStatus(response.data.user[0].name);
			}
		});
	}, []);

	return (
		<>
			<Header plant="fort-wayne" />
			<main>
				<HomeNav plant="fort-wayne" />
				<wrapper class="section-wrapper hmi-overview">
					{!loginStatus ? (
						<>
							<FWNavbar plant="fort-wayne" home />
							<container class="section-container" style={{ left: '105px' }}>
								<div class="side-box" style={{ position: 'absolute', top: '2vh', left: '1.45vw', width: '26vw', color: '#fff', height: '81vh' }}>
									<p style={{ fontWeight: 'bold', fontSize: 'large', textAlign: 'center', textShadow: '1px 1px 3px black' }}>
										The PowerPaint Human-Machine Interface (<b>HMI</b>) makes it easy to interact with the SMARTInspect system, check diagnostic data, and monitor job information as they pass through.
										<br />
										<br />
										Use the interactive <b>HMI</b> screen on the right to explore features of the system. Lightbulbs indicate that an element can be clicked on for additional information.
									</p>
									<div class="aux-buttons">
										<button class="aux-button" onClick={() => handleShowModal('Introduction to SMARTInspect', 'intro')}>
											<GiMicroscopeLens size={70} />
											Introduction to SMARTInspect
										</button>
										<button class="aux-button" onClick={() => handleShowModal('Configuration File Setup', 'config-setup')}>
											<MdOutlineSettings size={70} />
											Configuration
											<br />
											File Setup
										</button>
										<button class="aux-button" onClick={() => handleShowModal('Manual Stop / Start Procedure', 'start-stop')}>
											<MdLoop size={70} />
											Manual Stop / Start
											<br />
											Procedure
										</button>
										<button class="aux-button" onClick={() => handleShowModal('Server Power Shutdown / Startup', 'startup-shutdown')}>
											<FaPowerOff size={70} />
											Server Power
											<br />
											Shutdown / Startup
										</button>
									</div>
								</div>
								<content class="screen-layout" style={{ height: 'fit-content', width: 'fit-content', display: 'block', margin: '0 auto', position: 'absolute', left: '28vw', top: '4vh' }}>
									<img src={layout} alt="layout" style={{ width: '65vw' }} />

									<FaLightbulb size={25} class="bulb-link" style={{ left: '0%', top: '48%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '-1%', top: '0.5%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '11%', top: '6%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '70%', top: '3.5%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '33%', top: '96%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '88%', top: '-1%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '41%', top: '9%' }} />
									<FaLightbulb size={25} class="bulb-link" style={{ left: '79%', top: '12%' }} />

									<Dropdown className="screen-link logo-menu" style={{ width: '11.2%', height: '4.5%', left: '0%', top: '0%', cursor: 'pointer' }}>
										<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Logo Menu')}>
											<Dropdown.Toggle id="dropdown-basic" style={{ background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>
										</OverlayTrigger>

										<Dropdown.Menu>
											<OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('The PowerPaint HMI window exits full-screen mode and the window border becomes visible again, access to the Windows task-bar and desktop is now possible.')}>
												<Dropdown.Item>
													<img src={windows} style={{ width: '40px', marginRight: '0px' }} className="dropdown-icon" />
													Show Title Bar
												</Dropdown.Item>
											</OverlayTrigger>

											<OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('The PowerPaint HMI enters a full-screen mode where the only visible (and available) application is the HMI itself.')}>
												<Dropdown.Item>
													<MdCropFree size={30} className="dropdown-icon" />
													Fullscreen Mode
												</Dropdown.Item>
											</OverlayTrigger>

											<OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('The application is terminated.')}>
												<Dropdown.Item>
													<MdClose size={30} color="red" className="dropdown-icon" />
													Exit
												</Dropdown.Item>
											</OverlayTrigger>
										</Dropdown.Menu>
									</Dropdown>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Cell Overview Screen')}>
										<div onClick={() => handleShowModal('Cell Overview', 'cell-overview')} href="#" class="screen-link cell-overview" style={{ width: '16.5%', height: '4.5%', left: '43.5%', top: '8.5%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Default (Current) View')}>
										<div href="#" class="screen-link layout-menu" style={{ width: '3.1%', height: '2.5%', left: '90.5%', top: '0%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Side-by-Side View')}>
										<div href="#" onClick={() => handleShowModal('Side-by-Side View', 'horizontal-layout')} class="screen-link layout-menu" style={{ width: '3.5%', height: '2.5%', left: '93.5%', top: '0%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Top-Bottom View')}>
										<div href="#" onClick={() => handleShowModal('Top-Bottom View', 'vertical-layout')} class="screen-link layout-menu" style={{ width: '3.3%', height: '2.5%', left: '96.8%', top: '0%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Overhead Monitor 5 View')}>
										<div href="#" class="screen-link monitor" style={{ width: '14.2%', height: '34.5%', left: '12.5%', top: '59.1%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Overhead Monitor 4 View')}>
										<div href="#" class="screen-link monitor" style={{ width: '14.2%', height: '34.5%', left: '29.8%', top: '59.1%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Overhead Monitor 3 View')}>
										<div href="#" class="screen-link monitor" style={{ width: '14.2%', height: '34.5%', left: '46.7%', top: '59.1%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Overhead Monitor 2 View')}>
										<div href="#" class="screen-link monitor" style={{ width: '14.2%', height: '34.5%', left: '64%', top: '59.1%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Camera Status')}>
										<div href="#" class="screen-link camera-status" style={{ width: '20%', height: '77.5%', left: '79.6%', top: '16.1%' }} onClick={() => handleShowModal('Camera Status Sidebar', 'quick-cam-status')}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Tracking')}>
										<div href="#" class="screen-link tracking" style={{ width: '14%', height: '15.5%', left: '64.1%', top: '42%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Device Statuses')}>
										<div href="#" class="screen-link status" style={{ width: '31.7%', height: '10.6%', left: '12.3%', top: '44.1%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Vehicle Out of Inspect')}>
										<div href="#" class="screen-link s041" style={{ width: '14.4%', height: '24.2%', left: '12.4%', top: '15.9%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Inspect System')}>
										<div href="#" class="screen-link inspect" style={{ width: '14.3%', height: '24.2%', left: '29.7%', top: '15.9%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Vehicle On-Deck for Inspect')}>
										<div href="#" class="screen-link s080" style={{ width: '14.4%', height: '24.2%', left: '46.8%', top: '15.9%' }}></div>
									</OverlayTrigger>
									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Vehicle in Waiting')}>
										<div href="#" class="screen-link s079" style={{ width: '14.4%', height: '24.2%', left: '63.8%', top: '15.9%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Fault Alert Bar')}>
										<div onClick={() => handleShowModal('Fault Alert Bar', 'fault-viewer')} href="#" class="screen-link fault-viewer" style={{ width: '32.5%', height: '3.5%', left: '.1%', top: '96.7%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Monitoring Plugins')}>
										<Dropdown className="screen-link tab-menu monitoring" style={{ width: '5%', height: '2.5%', left: '72.8%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none', top: '0%' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('All Camera Status', 'camera-status')}>All Camera Status</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Job Queue', 'job-queue')}>Job Queue</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Service Process Viewer', 'service-process-viewer')}>Service Process Viewer</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Server Process Monitor', 'server-process-monitor')}>Server Process Monitor</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Service Monitor', 'service-monitor')}>Service Monitor</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Reports Plugins')}>
										<Dropdown className="screen-link tab-menu reports" style={{ width: '4%', height: '2.5%', left: '77.7%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('Scans Report', 'scans')}>Scans</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Scan Rate', 'scan-rate')}>Scan Rate</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Defects', 'defects')}>Defects</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Defect Detail', 'defect-detail')}>Defect Detail</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Faults', 'faults')}>Faults</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Offline Services', 'offline-services')}>Offline Services</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Change Log', 'change-log')}>Change Log</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Qvs Fault Viewer', 'QVS-fault-viewer')}>Qvs Fault Viewer</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Qvs Scan History', 'QVS-scan-history')}>Qvs Scan History</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Configuration Plugins')}>
										<Dropdown className="screen-link tab-menu config" style={{ width: '6%', height: '2.5%', left: '81.5%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('Hot Spot Editor', 'hotspot')}>Hot Spot Editor</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Style Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Plant Color Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Plant Color Family Setup', 'plant-color')}>Plant Color Family Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Plant Camera Override Setup', 'plant-camera-override')}>Plant Camera Override Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('JSON Editor', 'json-editor')}>JSON Editor</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Utility Plugins')}>
										<Dropdown className="screen-link tab-menu utility" style={{ width: '3.5%', height: '2.5%', left: '87.2%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('Defect Heat Map', 'defect-map')}>Defect Heat Map</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Network Diagnostic', 'network-diagnostic')}>Network Diagnostic</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Basic User Setup', 'user-setup')}>Basic User Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('PLC IO', 'plc-io')}>PLC IO</Dropdown.Item>

												<Dropdown.Item onClick={() => handleShowModal('Baseline Setup', 'baseline-setup')}>Baseline Setup</Dropdown.Item>
												<Dropdown.Item onClick={() => handleShowModal('Calculator', 'calculator')}>Calculator</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('System Recovery')}>
										<Dropdown className="screen-link tab-menu system-recovery" style={{ width: '6.8%', height: '2.5%', left: '90.5%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('System Recovery', 'recovery-screen')}>System Recovery</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Help')}>
										<Dropdown className="screen-link tab-menu help" style={{ width: '3.1%', height: '2.5%', left: '97.1%', top: '4%' }}>
											<Dropdown.Toggle id="dropdown-basic" style={{ position: 'absolute', background: 'none', width: '100%', height: '100%', border: 'none' }}></Dropdown.Toggle>

											<Dropdown.Menu>
												<Dropdown.Item onClick={() => handleShowModal('About', 'about')}>About</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</OverlayTrigger>

									<OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Plugin Menu')}>
										<div href="#" onClick={() => handleShowModal('Plugin Menu', 'plugin-menu')} class="screen-link plugin-menu" style={{ width: '10.6%', height: '18%', left: '0%', top: '6%' }}></div>
									</OverlayTrigger>

									<OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip('Sidebar Service Monitor')}>
										<div href="#" onClick={() => handleShowModal('Sidebar Service Monitor', 'service-sidebar')} class="screen-link sidebar-menu" style={{ width: '10.6%', height: '39%', left: '0%', top: '52.3%' }}></div>
									</OverlayTrigger>
								</content>
							</container>
						</>
					) : (
						<>
							<container class="section-container" style={{ width: '30%', background: 'white', padding: '20px', borderRadius: '1em', margin: 'auto auto', left: 0, display: 'flex' }}>
								<Form onSubmit={handleLogin}>
									<h2>Login</h2>
									<Form.Group className="mb-3">
										<Form.Label>Username</Form.Label>
										<Form.Control type="username" placeholder="Enter username" value={user} onChange={(event) => setUser(event.target.value)} />
									</Form.Group>

									<Form.Group className="mb-3">
										<Form.Label>Password</Form.Label>
										<Form.Control type="password" placeholder="Enter password" value={password} onChange={(event) => setPassword(event.target.value)} />
									</Form.Group>

									<Button variant="primary" type="submit">
										Submit
									</Button>
								</Form>

								<Form onSubmit={handleRegister}>
									<h2>Register</h2>

									<Form.Group className="mb-3">
										<Form.Label>Username</Form.Label>
										<Form.Control type="username" placeholder="Enter username" value={userReg} onChange={(event) => setUserReg(event.target.value)} />
									</Form.Group>

									<Form.Group className="mb-3">
										<Form.Label>Password</Form.Label>
										<Form.Control type="password" placeholder="Enter password" value={passwordReg} onChange={(event) => setPasswordReg(event.target.value)} />
									</Form.Group>

									<Button variant="primary" type="submit">
										Submit
									</Button>
								</Form>
								{/* <Button
									variant="secondary"
									type=""
									onClick={() => {
										axios.post('http://localhost:3001/api/insert', {
											username: 'doug',
											password: 'password',
										});
									}}
								>
									Test
								</Button> */}
							</container>
						</>
					)}
				</wrapper>
			</main>
			<Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="course-modal" centered>
				<Modal.Header closeButton>
					<Modal.Title>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ModalContent content={modal.content} />
				</Modal.Body>
			</Modal>
			<Footer />
		</>
	);
};

export default SIOverview;
